/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { Checkbox } from "../../../../shared/Checkbox/Checkbox.js";
import { history } from "../../../../history";

import { AppTranslation } from "../../../../i18n/useAppTranslation.js";

import { Button } from "../../../../shared/Button/Button.js";

import styles from "../procedure-details.module.scss";

export function ProcedureHeader({
  doThis,
  openResponseModal,
  signThis,
  updateSignToList,
  handleRestoreModal,
  isAddDisabledClass,
  settingsLang,
  openSignModal,
  isFromChartAuditReport,
  openRequestModal,
  roomType,
  action,
  mdChangesNeeded,
  requestedNotes,
  mdChangesDone,
  languageData,
  showLoader,
  firstname,
  lastname,
  procedure_name,
  md_signed,
  sentToMd,
  userRoomData,
  signList,
  procedureID,
  propsParams,
}) {
  const hasPictures =
    userRoomData.procedure_image ||
    userRoomData.procedure_image_45 ||
    userRoomData.is_procedure_image;
  const hasTraceability = userRoomData.is_trace_complete;
  const hasNotes = userRoomData.procedure_notes_count > 0;
  const hasConsent = userRoomData.show_consents_btn > 0;
  const hasPaymentTransaction = userRoomData.pos_invoices_count > 0;
  const hasQuestionnaire = userRoomData.show_questionnaires_btn > 0;

  const { isComplete, signText } = useMemo(() => {
    if (
      hasPictures &&
      hasTraceability &&
      hasNotes &&
      hasConsent &&
      hasPaymentTransaction &&
      hasQuestionnaire
    ) {
      return {
        isComplete: 1,
        signText: "Sign",
      };
    } else {
      return {
        isComplete: 0,
        signText: languageData.pro_sign_incomplete,
      };
    }
  }, [
    hasPictures,
    hasTraceability,
    hasNotes,
    hasConsent,
    hasPaymentTransaction,
    hasQuestionnaire,
  ]);

  const { isAfterPhotos, markAsAfterText } = useMemo(() => {
    if (userRoomData.is_after_photos === 1) {
      return {
        isAfterPhotos: 0,
        markAsAfterText: languageData.pro_unmark_as_after_photos,
      };
    } else {
      return {
        isAfterPhotos: 1,
        markAsAfterText: languageData.pro_mark_as_after_photos,
      };
    }
  }, [userRoomData]);

  const isMdRoom = roomType === "md-room";
  const isCheckMarAvailable = !(isMdRoom && mdChangesNeeded);
  const actionPending = action === "pending";

  const canRequest =
    (actionPending && !requestedNotes && isMdRoom) ||
    (Boolean(mdChangesDone) && isMdRoom);

  const getReturnUrl = () => {
    if (action) {
      if (action === "recently-deleted") {
        return "/settings/recently-deleted-procedures";
      }
      return "/" + roomType + "/" + action;
    }
    return "pending";
  };

  const changeReturnUrl = () => {
    if (history.location.state) {
      return {
        pathname: getReturnUrl(),
        state: history.location.state,
      };
    } else {
      return getReturnUrl();
    }
  };

  return (
    <div className="modal-blue-header">
      <Link to={changeReturnUrl()} className="popup-cross">
        ×
      </Link>

      {showLoader === false && (
        <span className="popup-blue-name">
          {firstname} {lastname + `-`} {procedure_name}
        </span>
      )}

      {isMdRoom && actionPending && !showLoader ? (
        <div className={styles.hederActions}>
          {canRequest && (
            <Button
              type="button"
              size="small"
              color="error"
              onClick={openRequestModal}
            >
              <AppTranslation.ProviderRoom path="label.requestInfo" />
            </Button>
          )}

          {roomType &&
            roomType === "md-room" &&
            (Boolean(mdChangesNeeded) || Boolean(mdChangesDone)) && (
              <Button
                type="button"
                color="error"
                size="small"
                onClick={openResponseModal}
              >
                <AppTranslation.ProviderRoom path="label.viewRequest" />
              </Button>
            )}

          {md_signed !== 1 && !mdChangesNeeded ? (
            <Button
              type="submit"
              size="small"
              className={`new-blue-btn pull-right consent-model ${isAddDisabledClass}`}
              onClick={openSignModal}
              isDisabled={isFromChartAuditReport}
            >
              {languageData.pro_text_sgn}
            </Button>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}

      {!sentToMd && action === "signed" && (
        <div className={styles.hederActions}>
          <Button
            type="submit"
            size="small"
            isDisabled={isFromChartAuditReport}
            className={`new-blue-btn pull-right consent-model m-r-5 ${isAddDisabledClass}`}
            onClick={signThis}
          >
            <AppTranslation.ProviderRoom path="label.sendToMd" />
          </Button>
        </div>
      )}

      {roomType === "provider-room" && showLoader === false ? (
        <div className={styles.hederActions}>
          {Boolean(mdChangesNeeded) && action === "sent-to-md" && (
            <Button
              type="button"
              color="error"
              size="small"
              onClick={openResponseModal}
            >
              <AppTranslation.ProviderRoom path="label.viewRequest" />
            </Button>
          )}

          {Boolean(mdChangesNeeded) && action === "sent-to-md" && (
            <Button
              type="submit"
              size="small"
              className={`new-blue-btn pull-right consent-model ${isAddDisabledClass}`}
              onClick={openSignModal}
              isDisabled={isFromChartAuditReport}
            >
              {action === "sent-to-md" && (
                <AppTranslation.ProviderRoom path="label.sendToMd" />
              )}
            </Button>
          )}

          {action === "pending" && roomType === "provider-room" && (
            <div className="dropdown show-hide-btn ">
              <button
                className={`line-btn ${isAddDisabledClass}`}
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
                disabled={isFromChartAuditReport}
              >
                Actions <i className="fas fa-angle-down"></i>
              </button>

              <ul className="dropdown-menu" aria-labelledby="dropdownMenu1">
                <li>
                  <a
                    onClick={doThis}
                    className="sign-procedure sign-procedure-class"
                    data-consult="0"
                    data-procedureid={userRoomData.id}
                    data-iscomplete={isComplete}
                    data-action={
                      isComplete === 0 ? "incompletesign" : "completesign"
                    }
                  >
                    {signText}
                  </a>
                </li>

                <li>
                  <a
                    onClick={doThis}
                    className="sign-as-consult sign-procedure-class"
                    data-consult="1"
                    data-procedureid={userRoomData.id}
                    data-action="markconsult"
                  >
                    Mark as consult
                  </a>
                </li>

                <li>
                  <a
                    onClick={doThis}
                    className="mark-as-after-photo sign-procedure-class"
                    data-procedureid={userRoomData.id}
                    data-isafterphotos={isAfterPhotos}
                    data-action={
                      isAfterPhotos === 0
                        ? "unmarkafterphoto"
                        : "markafterphoto"
                    }
                  >
                    {markAsAfterText}
                  </a>
                </li>

                {userRoomData.is_after_photos === 1 && (
                  <li>
                    <a
                      onClick={doThis}
                      className="hide-procedure sign-procedure-class"
                      data-procedureid={userRoomData.id}
                      data-action="hide"
                    >
                      Hide
                    </a>
                  </li>
                )}
              </ul>
            </div>
          )}
        </div>
      ) : (
        ""
      )}

      {((propsParams.type === "pending" && isCheckMarAvailable) ||
        (!sentToMd && action === "signed")) &&
        showLoader === false && (
          <div className={styles.signBlock}>
            <Checkbox
              isChecked={signList?.includes(Number(procedureID))}
              onChange={() => updateSignToList()}
            />
            <div className={styles.signText}>
              <AppTranslation.ProviderRoom path="label.markForBulkSignature" />
            </div>
          </div>
        )}

      {action && action === "recently-deleted" && showLoader === false ? (
        <div className="popup-new-btns popup-new-btns-restore">
          <button
            className="header-select-btn confirm-model m-r-15"
            data-confirm-url=""
            data-message={settingsLang.recently_deleted_restore_msg}
            onClick={handleRestoreModal}
          >
            {settingsLang.recently_deleted_restore}
          </button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
